<template>
  <v-card :class="{ showRoomCalendar: showRoomCalendar }" flat class="noSelect" v-for="(table, tableIndex) in tables"
    v-if="items" @mouseup="endAllFallback()"
    style="position: relative;">
    <v-btn v-if="isNative || isMobile" style="position: fixed; bottom: 0; right: 0; width: 60px!important; height: 55px!important; z-index: 999; " flat class="primaryButton mr-3 mb-6" @click="addNewSlot"><v-icon size="x-large">mdi-plus</v-icon></v-btn>
    <div @mousemove="handleDrag" class="pa-4 mb-8" style="flex-grow: 1; height: 100%">
      <v-container fluid style="height: 100%">
        <v-row style="height: 100%">
          <v-col class="pa-0" :cols="timeCols" style="display: flex; flex-direction: column; max-width: 100px;">
            <div class="" style="overflow: hidden; overflow: hidden; white-space: nowrap">
              <div v-if="columnHeaders" style="display: flex" :style="{ height: columnHeaders ? '22px' : '0px' }"></div>
              <span style="opacity: 0" v-html="table[0].value"></span>
              <div v-if="roomHeaders" style="display: flex" :style="{ height: roomHeaders ? '22px' : '0px' }"></div>

            </div>
            <div :style="{ height: heightPerSlot + 'px !important' }" v-for="(row, rowIndex) in rows"
              :key="'timerow_' + rowIndex" class="alternatingRow outlinedTop pa-1"
              :class="{ outlinedBottom: rowIndex == rows.length - 1 }" style="
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
                flex-wrap: wrap;
              ">
              <div style="text-align: center;"
                :style="{ 'font-weight': rowIndex % 2 == 0 ? 'bold' : 'regular', opacity: rowIndex % 2 == 0 ? 0.8 : 0.5 }">
                {{
                  row.value }}</div>
            </div>
          </v-col>
          <v-col class="pa-0" :cols="secondaryCols" style="
              display: flex;
              overflow-x: auto; /* Enable horizontal scrolling */
              overflow-y: hidden; /* Disable vertical scrolling */
              overscroll-behavior-x: contain; /* Prevent unexpected behaviors */
              align-items: flex-start;
              flex-grow: 1;
            ">
            <div v-for="(col, colIndex) in table" :key="'col_' + colIndex" style="
                display: flex;
                align-items: center;
                flex-direction: column;
                position: relative;
                justify-content: center;
              " :style="{ width: 100 / table.length + '%', opacity: col.col == -1 ? 0.2 : 1 }"
              class="alternatingCol  outlinedRight" :class="{
                outlinedLeft: colIndex == 0,
              }">
              <div style="width: 100%" :class="{
                'green-background': col.header && col.header.length > 0,
              }" class="overflow-ellipsis" @click="showEditCourse(col)">
                <div v-if="columnHeaders" style="display: flex; justify-content: center"
                  :style="{ height: columnHeaders ? '22px' : '0px' }">
                  <div v-for="(header, headerIndex) in col.header">
                    <v-tooltip :text="header.tooltip">
                      <template v-slot:activator="{ props }">
                        <div v-bind="props">
                          <v-icon v-if="header.icon" class="icon-transparency">{{
                            header.icon
                          }}</v-icon>
                          <div>
                            {{ header.text }}
                          </div>
                        </div>
                      </template>
                    </v-tooltip>
                  </div>
                </div>
                <div class="lightText" style="width: 100%"></div>
                <div v-html="col.value" class="lightText" style="width: 100%; text-align: left"></div>
                <div v-if="roomHeaders" style="display: flex; justify-content: space-between"
                  :style="{ height: roomHeaders ? '22px' : '0px' }">
                  <div v-for="(header, headerIndex) in col.rooms">
                    {{ header }}
                  </div>
                </div>
              </div>


              <div @mouseup="endDrag" @mousedown="startDrag" :style="{ height: heightPerSlot + 'px !important' }"
                v-for="(row, rowIndex) in rows" :key="'row_' + colIndex + '_' + rowIndex"
                class="alternatingRow outlinedTop" :class="{
                  outlinedBottom: rowIndex == rows.length - 1,
                }" style="
                  display: flex;
                  align-content: center;
                  flex-direction: column;
                  flex-wrap: wrap;
                  justify-content: center;
                  width: 100%;
                  position: relative;
                  overflow-x: clip;
                ">

                <div style="width: 100%; height: 100%"
                  :style="{ 'z-index': activeElem ? 999 : 0, 'background-color': getBackgroundColor(table, rowIndex, colIndex) }"
                  @mouseover="setCurrentField($event, tableIndex, rowIndex, colIndex)"></div>

                <div v-for="(item, itemIndex) in items[rowIndex][
                  colIndex + tableIndex * maxDays
                ].items" style="position: absolute; top: 1%; z-index: 99; cursor: pointer" :style="{
                  width:
                    calcWidth(tableIndex, rowIndex, colIndex),
                  left:
                    calcLeft(tableIndex, rowIndex, colIndex, itemIndex),
                  'pointer-events': item.value.created ? 'none' : 'all',
                }" :id="'card_' +
                  tableIndex +
                  '_' +
                  rowIndex +
                  '_' +
                  colIndex +
                  '_' +
                  item.value.id
                  ">
                  <TimeTableCard :userColors="availUsers" :profileView="profileView"
                    @mousedown="startDrag($event, item)" :item="item"
                    @denyTimeSlot="denyTimeSlot" @acceptSuggestion="acceptSuggestion" :heightPerSlot="heightPerSlot"
                    :showRoomCalendar="showRoomCalendar" :errors="getErrorsByTimeSlots(item, col)" />

                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-card>
</template>

<script>
import { Capacitor } from "@capacitor/core";
import TimeTableCard from "./TimeTableCard.vue";

export default {
  name: "calendarDailyComponent",

  props: [
    "timeTable",
    "heightPerSlot",
    "refresh",
    "columnLength",
    "startColumn",
    "columns",
    "columnHeaders",
    "roomHeaders",
    "readonly",
    "showCancelled",
    "activeTimeSlot",
    "duplicationMode",
    "showRoomCalendar",
    "maxDays",
    "availUsers",
    "freeRooms",
    "availRooms",
    "profileView"
  ],
  emits: ["clickSlot", "showEditCourse", "requestRefresh"],

  data() {
    return {
      dragging: false,
      startY: 0,
      startOffsetTop: 0,

      activeElem: undefined,
      draggedItemCopy: undefined,
      newElem: undefined,
      startingColumn: [],
      eventNode: undefined,

      activeTableIndex: null,
      activeRowIndex: null,
      activeColIndex: null,

      needForRAF: true,

      availTeachers: undefined,
    };
  },

  components: {
    TimeTableCard,
  },

  computed: {
    rows() {
      if (!this.timeTable) return [];

      let result = [];

      for (let i = 0; i < this.timeTable.time_units.length; i++) {
        let start_time_temp = this.timeTable.time_units[i].start_time.split(":");
        let end_time_temp = this.timeTable.time_units[i].end_time.split(":");

        result.push({
          row: this.timeTable.time_units[i].id,
          value:
            start_time_temp[0] +
            ":" +
            start_time_temp[1],
        });
      }

      return result;
    },
    items() {
      if (!this.timeTable) {
        return;
      }

      let result = [];

      if (this.maxDays == 7) {
        for (let row = 0; row < this.rows.length; row++) {
          result.push([]);

          for (let col = 0; col < this.columns.length; col++) {
            let items = this.getTimeUnits(this.rows[row].row, this.columns[col].col);
            let amount = this.getAmount(this.rows[row].row, this.columns[col].col);

            result[result.length - 1].push({
              row: this.rows[row].row,
              col: this.columns[col].col,
              items: this.columns[col].col == -1 ? [] : items,
              amount: amount,
            });
          }
        }
      }
      else {
        for (let row = 0; row < this.rows.length; row++) {
          result.push([]);

          for (let col = this.startColumn; col < this.startColumn + this.maxDays; col++) {
            let items = this.getTimeUnits(this.rows[row].row, this.columns[col].col);
            let amount = this.getAmount(this.rows[row].row, this.columns[col].col);

            result[result.length - 1].push({
              row: this.rows[row].row,
              col: this.columns[col].col,
              items: this.columns[col].col == -1 ? [] : items,
              amount: amount,
            });
          }
        }
      }

      // adjust amounts for all cols
      for (let row = 0; row < result.length; row++) {
        for (let col = 0; col < result[row].length; col++) {
          for (let item = 0; item < result[row][col].items.length; item++) {
            let temp = result[row][col].items[item];
            if (temp.rendered) {
              let amountMax = 0;
              for (let i = row; i < row + temp.duration; i++) {
                if (i > result.length) {
                  //avoid crashing at end of day
                  continue;
                }

                if (result[i][col].amount > amountMax) {
                  amountMax = result[i][col].amount;
                }
              }

              for (let i = row; i < row + temp.duration; i++) {
                result[i][col].amount = amountMax;
              }
            }
          }
        }
      }
      return result;
    },
    tables() {
      let result = [];

      if (this.maxDays == 7) {
        for (let i = 0; i < this.columns.length; i++) {
          if (!result[parseInt(i / this.maxDays)]) {
            result[parseInt(i / this.maxDays)] = [];
          }

          if (this.columnHeaders) {
            this.columns[i].header = this.columnHeaders[i];
          }
          if (this.roomHeaders) {
            this.columns[i].rooms = this.roomHeaders[i];
          }
          result[parseInt(i / this.maxDays)].push(this.columns[i]);
        }
      }
      else {
        result[0] = [];
        for (let i = this.startColumn; i < this.startColumn + this.maxDays; i++) {

          if (this.columnHeaders) {
            this.columns[i].header = this.columnHeaders[i];
          }
          if (this.roomHeaders) {
            this.columns[i].rooms = this.roomHeaders[i];
          }
          result[0].push(this.columns[i]);
        }
      }

      return result;
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return true;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
    secondaryCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return undefined;
        case "sm":
          return undefined;
        case "md":
          return undefined;
        case "lg":
          return undefined;
        case "xl":
          return undefined;
        case "xxl":
          return undefined;
        default:
          return undefined;
      }
    },
    timeCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        case "md":
          return 1;
        case "lg":
          return 'auto';
        case "xl":
          return 'auto';
        case "xxl":
          return 'auto';
        default:
          return 1;
      }
    },
    deniedByTherapistStatus() {
      if (!this.statusChoices) {
        return
      }

      for (let i = 0; i < this.statusChoices.length; i++) {
        if (this.statusChoices[i].value == "denied_by_therapist") {
          return i
        }
      }

      return
    },
    isTouchDevice() {
    return (
      window.matchMedia("(pointer: coarse)").matches ||
      navigator.maxTouchPoints > 0 ||
      "ontouchstart" in window
    );
    },

    isNative(){
      if(Capacitor.isNativePlatform()){
        return true
      } else {
        return false
      }
    },

  },

  watch: {
    refresh() { },
  },

  methods: {
    mixColors(colors) {
      const toRGB = (hex) => ({
        r: parseInt(hex.substr(1, 2), 16),
        g: parseInt(hex.substr(3, 2), 16),
        b: parseInt(hex.substr(5, 2), 16),
      });

      const toHex = (v) =>
        v.toString(16).padStart(2, '0');

      let r = 0, g = 0, b = 0;

      colors.forEach(hex => {
        const c = toRGB(hex);
        r += c.r;
        g += c.g;
        b += c.b;
      });

      const n = colors.length;

      r = Math.round(r / n);
      g = Math.round(g / n);
      b = Math.round(b / n);

      return `#${toHex(r)}${toHex(g)}${toHex(b)}60`;
    },
    getBackgroundColor(table, rowIndex, colIndex) {
      if (!this.tables || !this.freeRooms) {
        return ""
      }

      let timeRef = this.rows[rowIndex].value

      for (let i = 0; i < this.freeRooms[colIndex].length; i++) {
        if (this.freeRooms[colIndex][i].start_time.startsWith(timeRef)) {
          if (this.profileView) {
            return ""
          }
          else {
            return this.mixColors(this.freeRooms[colIndex][i].rooms.map(r => r.color_code))
          }
        }
      }
      if (this.profileView) {
        return "rgba(var(--v-theme-background), 1)"
      }
      else {
        return ""
      }
    },
    calcWidth(tableIndex, rowIndex, colIndex) {
      if (!this.items) {
        return
      }

      if (this.showRoomCalendar && this.roomHeaders) {
        return "calc(" + (100 / this.roomHeaders[0].length) + "% - 2px)"
      }
      else {
        return 'calc(' +
          100 / this.items[rowIndex][colIndex + tableIndex * this.maxDays].amount +
          '% - 2px)'
      }
    },
    calcLeft(tableIndex, rowIndex, colIndex, itemIndex) {
      if (!this.items) {
        return
      }

      if (this.showRoomCalendar && this.roomHeaders) {
        let actualIndex = 0

        if (!this.items[rowIndex][colIndex + tableIndex * this.maxDays].items[itemIndex].value.rooms ||
          this.items[rowIndex][colIndex + tableIndex * this.maxDays].items[itemIndex].value.rooms.length == 0
        ) {
          return (((this.roomHeaders[0].length - 1) * 100) /
            this.roomHeaders[0].length) +
            '% !important'
        }
        else {
          for (let i = 0; i < this.roomHeaders[0].length; i++) {
            for (let j = 0; j < this.items[rowIndex][colIndex + tableIndex * this.maxDays].items[itemIndex].value.rooms.length; j++) {
              if (this.items[rowIndex][colIndex + tableIndex * this.maxDays].items[itemIndex].value.rooms[j].name == this.roomHeaders[0][i]) {
                return (((i) * 100) /
                  this.roomHeaders[0].length) +
                  '% !important'
              }
            }
          }
        }
        return 0
      }
      else {
        return ((itemIndex * 100) /
          this.items[rowIndex][colIndex + tableIndex * this.maxDays].amount) +
          '% !important'
      }
    },
    acceptSuggestion() {
      if (!this.slotData.id) {
        return
      }

      let formData = {
        id: this.slotData.id,
        accepted_by_therapist: true
      }

      this.patchOrPostData(formData)
    },
    patchOrPostData(formData) {
      this.axios
        .patch(this.axios.defaults.baseURL + "calendar/timeslots/patch/", formData)
        .then((resp) => {
          this.$emit("close", 1);
        })
        .catch((e) => {
          this.$emit("loading", false);
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    denyTimeSlot() {
      if (!this.slotData.id) {
        return
      }

      let formData = {
        id: this.slotData.id,
        status: this.deniedByTherapistStatus
      }

      this.patchOrPostData(formData)

    },
    isCancelled(slot) {
      if (!slot.id) {
        return false
      }

      return slot.display_status != "planned"
    },
    endAllFallback() {
      this.activeElem = undefined;
      this.draggedItemCopy = undefined;
      this.dragging = false;
      this.needForRAF = true;
    },
    getErrorsByTimeSlots(item, col) {
      if (!this.timeTable || !this.timeTable.errors) {
        return
      }

      if (!item || !item.value) {
        return
      }

      let result = []
      for (let i = 0; i < this.timeTable.errors.length; i++) {
        if (this.timeTable.errors[i].slots) {
          for (let j = 0; j < this.timeTable.errors[i].slots.length; j++) {
            if (item.value.id == this.timeTable.errors[i].slots[j].id) {
              result.push(this.timeTable.errors[i])
            }
          }
        }
      }


      item.value.errors = result
      return result
    },
    showEditCourse(col) {
      this.$emit("showEditCourse", col)
    },
    getTimeUnits(row, col) {
      let colTemp = this.timeTable.dates[col];

      let result = [];
      for (let i = 0; i < this.timeTable.time_slots.length; i++) {
        let slot = this.timeTable.time_slots[i];

        if (this.showCancelled || !this.isCancelled(slot)) {
          if (slot.date_index == colTemp) {
            for (let j = 0; j < slot.time_units.length; j++) {
              if (slot.time_units[j].id == row) {
                result.push({
                  value: slot,
                  duration: slot.time_units.length,
                  rendered: j == 0,
                });
              }
            }
          } else if (slot.date == colTemp) {
            for (let j = 0; j < slot.time_units.length; j++) {
              if (slot.time_units[j].id == row) {
                result.push({
                  value: slot,
                  duration: slot.time_units.length,
                  rendered: j == 0,
                });
              }
            }
          }
        }
      }

      return result;
    },
    getAmount(row, col) {
      let colTemp = this.timeTable.dates[col];


      let amount = 0;


      for (let i = 0; i < this.timeTable.time_slots.length; i++) {
        let slot = this.timeTable.time_slots[i];

        if (this.showCancelled || !this.isCancelled(slot)) {
          if (slot.date_index == colTemp) {
            for (let j = 0; j < slot.time_units.length; j++) {
              if (slot.time_units[j].id == row) {
                amount++;
              }
            }
          } else if (slot.date == colTemp) {
            for (let j = 0; j < slot.time_units.length; j++) {
              if (slot.time_units[j].id == row) {
                amount++;
              }
            }
          }
        }
      }


      return amount;
    },
    setCurrentField(event, tableIndex, rowIndex, colIndex) {
      event.stopPropagation();
      event.preventDefault();

      if (this.readonly) {
        return;
      }

      this.activeTableIndex = tableIndex;
      this.activeRowIndex = rowIndex;
      this.activeColIndex = colIndex;
    },
    update() {
      setTimeout(() => {
        this.needForRAF = true;
      }, 100);
    },
    startDrag(event, item) {
      event.stopPropagation();
      event.preventDefault();


      this.dragging = true;
      this.$forceUpdate()

      if (
        this.activeColIndex < 0 ||
        this.activeTableIndex * this.maxDays + this.activeColIndex >=
        this.columnLength + this.startColumn
      ) {
        console.log("col not matching: return")
        return;
      }
      if (this.activeElem) {
        console.log("activeElem exists: return")
        return;
      }

      if (item && !item.value.readable) {
        return
      }

      if (!this.readonly) {
        this.handleStartDrag();


        if (this.eventNode) {
          console.log("eventNode exists: return")
          return;
        }
      }
      console.log(item)
      this.startY = event.clientY;
      if (item) {
        let temp = event.srcElement.parentNode;
        let maxSteps = 20;

        while (maxSteps > 0 && !temp.id.startsWith("card_")) {
          maxSteps--;

          temp = temp.parentNode;
        }

        temp = temp.id.split("_");

        this.activeElem = {
          id: temp[temp.length - 1],
          item: item,
        };

        this.draggedItemCopy = JSON.parse(JSON.stringify(item));
      }

      this.newElem = {
        table: this.activeTableIndex,
        row: this.activeRowIndex,
        col: this.activeColIndex - this.startColumn,
        item: this.duplicationMode && this.activeTimeSlot ? this.activeTimeSlot : undefined
      };

      this.startingColumn = this.activeColIndex - this.startColumn;
      console.log("success")
    },
    handleDrag(event) {
      if (this.readonly) {
        return;
      }

      if (
        this.activeColIndex < 0 ||
        this.activeTableIndex * this.maxDays + this.activeColIndex >=
        this.columnLength + this.startColumn
      ) {
        return;
      }

      if (this.needForRAF && this.dragging) {
        this.needForRAF = false;

        if (this.activeElem) {
          this.handleMoveSlot({
            id: this.activeElem.id,
            row: this.activeRowIndex,
            col:
              this.activeTableIndex * this.maxDays +
              this.activeColIndex -
              this.startColumn,
          });
        } else if (this.newElem) {
          this.handleNewSlot({
            row1: this.newElem.row,
            row2: this.activeRowIndex,
            col: this.newElem.table * this.maxDays + this.newElem.col,
            item: this.newElem.item
          });
        }
      }

      this.startY = event.clientY;

      this.update();
    },
    endDrag(event) {
      if (this.dragging) {
        let isClicked = false;

        if (this.activeElem && this.draggedItemCopy) {
          //check if item was moved at all between mouse down and mouse up
          //if yes its a drag, if no its a click
          if (this.draggedItemCopy.value.date == this.activeElem.item.value.date) {
            for (let i = 0; i < this.draggedItemCopy.value.time_units.length; i++) {
              if (
                this.draggedItemCopy.value.time_units[i].id ==
                this.activeElem.item.value.time_units[i].id
              ) {
                this.$emit("clickSlot", this.activeElem.item.value);

                isClicked = true;
                console.log("was clicked")
                break
              }
            }
          }
        }

        if (this.readonly) {
          console.log("readonly, returning")
          return;
        }

        if (!isClicked) {
          this.handleEndDrag(this.activeElem ? this.activeElem.id : undefined);

          console.log("handled end drag")
        }

        this.activeElem = undefined;
        this.draggedItemCopy = undefined;
        this.dragging = false;
        this.needForRAF = true;

        console.log("done end")
      }
    },

    handleStartDrag(column) {
      if (this.readonly) {
        return;
      }

      if (!this.timeTable.time_slots) {
        return
      }

      for (let i = 0; i < this.timeTable.time_slots.length; i++) {
        if (this.timeTable.time_slots[i].created) {
          this.timeTable.time_slots.splice(i, 1);
        }
      }
    },
    handleEndDrag(activeID) {
      if (this.readonly) {
        return;
      }

      if (activeID) {
        for (let i = 0; i < this.timeTable.time_slots.length; i++) {
          if (this.timeTable.time_slots[i].id == activeID) {
            let temp = {
              id: this.timeTable.time_slots[i].id,
              date: this.timeTable.time_slots[i].date,
              date_index: this.timeTable.time_slots[i].date_index,
              time_units: this.timeTable.time_slots[i].time_units,
            };

            this.patchData(temp);
            return;
          }
        }
      } else {
        if (this.timeTable.time_slots) {
          for (let i = 0; i < this.timeTable.time_slots.length; i++) {
            if (this.timeTable.time_slots[i].created) {
              this.$emit("clickSlot", this.timeTable.time_slots.splice(i, 1)[0]);
              return;
            }
          }
        }
      }
    },

    addNewSlot(){
      const slot = {
              row1: this.activeRowIndex ?? 0,
              row2: this.activeRowIndex ?? 0,
              col: this.activeTableIndex !== null && this.activeColIndex !== null
              ? this.activeTableIndex * this.maxDays +
                this.activeColIndex -
                this.startColumn
              : 0
            }

      this.handleNewSlot(slot)

      if (this.timeTable.time_slots) {
        for (let i = 0; i < this.timeTable.time_slots.length; i++) {
          if (this.timeTable.time_slots[i].created) {
            this.$emit("clickSlot", this.timeTable.time_slots.splice(i, 1)[0]);
            return;
          }
        }
      }
    },

    patchData(formData) {
      if (this.readonly) {
        return;
      }

      formData["type"] = "course";
      formData["course"] = this.$route.params.courseID;


      this.axios
        .patch(this.axios.defaults.baseURL + "calendar/timeslots/patch/", formData)
        .then((resp) => {
          this.$emit("requestRefresh")
        })
        .catch((e) => {
          console.log(e);
          window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
        });
    },
    handleMoveSlot(value) {
      if (this.readonly) {
        return;
      }

      if (value.id && value.row >= 0 && value.col >= 0 && this.timeTable.time_slots && this.timeTable.time_slots.length) {
        for (let i = 0; i < this.timeTable.time_slots.length; i++) {
          let slot = this.timeTable.time_slots[i];
          if (slot.id == value.id) {
            slot.date = this.isTemplate ? value.col : this.timeTable.dates[value.col];
            slot.date_index = value.col;

            if (this.timeTable.time_units.length >= slot.time_units.length + value.row) {
              let newTime = this.timeTable.time_units[value.row];
              for (let j = 0; j < slot.time_units.length; j++) {
                slot.time_units[j] = JSON.parse(JSON.stringify(newTime));
                newTime = this.timeTable.time_units[value.row + j + 1];
              }
            }

            break;
          }
        }
      }
    },
    handleNewSlot(value) {
      if (this.readonly) {
        return;
      }

      if (value.row1 >= 0 && value.row2 >= 0 && value.col >= 0) {
        let timeUnits = [];
        for (let i = value.row1; i <= value.row2; i++) {
          timeUnits.push(this.timeTable.time_units[i]);
        }
        console.log(value)
        let newItem
        if (value.item && this.activeTimeSlot && this.duplicationMode) {
          let duplicatedTimeUnits = [timeUnits[0]]
          let addBoolTemp = false
          let count = this.activeTimeSlot.time_units.length - 1
          for (let i = 0; i < this.timeTable.time_units.length; i++) {
            if (addBoolTemp) {
              duplicatedTimeUnits.push(JSON.parse(JSON.stringify(this.timeTable.time_units[i])))
              count--
            }
            if (count == 0) {
              break
            }

            //skip first, cause its already in there
            if (this.timeTable.time_units[i].start_time == duplicatedTimeUnits[0].start_time) {
              addBoolTemp = true
            }
          }

          newItem = JSON.parse(JSON.stringify(value.item))

          newItem.id = 0
          newItem.date = this.timeTable.dates[value.col]
          newItem.time_units = duplicatedTimeUnits
          newItem.prev = value.item
          newItem.created = true
        }

        else {
          newItem = {
            id: 0,
            date: this.isTemplate ? value.col : this.timeTable.dates[value.col],
            date_index: this.isTemplate ? value.col : this.timeTable.dates[value.col],
            time_units: timeUnits,
            is_temporary: false,
            created: true,
          };
        }

        for (let i = 0; i < this.timeTable.time_slots.length; i++) {
          if (this.timeTable.time_slots[i].created) {
            this.timeTable.time_slots[i] = newItem;
            return;
          }
        }

        this.timeTable.time_slots.push(newItem);
      }
    },
    fetchStatusChoices() {

    }
  },

  mounted() {
    this.fetchStatusChoices()
  },
};
</script>

<style scoped>
.outlinedLeft {
  border-left: 2px solid rgba(var(--v-theme-background), 0.6);
}

.outlinedRight {
  border-right: 2px solid rgba(var(--v-theme-background), 0.6);
}

.showRoomCalendar .outlinedLeft {
  border-left: 2px solid rgba(var(--v-theme-secondary), 0.2);
}

.showRoomCalendar .outlinedRight {
  border-right: 2px solid rgba(var(--v-theme-secondary), 0.2);
}

.outlinedTop {
  border-top: 2px solid rgba(var(--v-theme-background), 0.6);
}

.outlinedBottom {
  border-bottom: 2px solid rgba(var(--v-theme-background), 0.6);
}


.lightText {
  opacity: 0.6;
}
</style>
